/// <reference path='typings/index.d.ts' />

/// <reference path='dg.ts' />

/// <reference path='src/domain/Domain.d.ts' />
/// <reference path='src/domain/Enums.ts' />

/// <reference path='src/ui-router/dg-ui-router.module.ts' />
/// <reference path='src/ui-router/dg-state-provider.service.ts' />
/// <reference path='src/ui-router/ui-router.ts' />


/// <reference path='src/templates/dg.templates.ts' />

/// <reference path='src/utils/dg-utils.module.ts' />
/// <reference path='src/utils/dg-filter.service.ts' />
/// <reference path='src/utils/dg-ui.service.ts' />
/// <reference path='src/utils/dg-angular-filters-interfaces.ts' />
/// <reference path='src/utils/dg-camel-to-dashes.filter.ts' />
/// <reference path='src/utils/dg-dashes-to-camel.filter.ts' />
/// <reference path='src/utils/dg-guid.service.ts' />
/// <reference path='src/utils/dg-state.service.ts' />
/// <reference path='src/utils/dg-location.service.ts' />
/// <reference path='src/utils/dg-duration.filter.ts' />
/// <reference path='src/utils/props.filter.ts' />
/// <reference path='src/utils/dg-is-empty-prop.filter.ts' />
/// <reference path='src/utils/dg-date.filter.ts' />
/// <reference path='src/utils/dg-links-by-rel.filter.ts' />
/// <reference path='src/utils/dg-enabled-links.filter.ts' />
/// <reference path='src/utils/dg-filter-by-many.ts' />
/// <reference path='src/utils/dg-query-object-to-dot-notion.filter.ts' />
/// <reference path='src/utils/dg-select-on-click.ts' />
/// <reference path='src/utils/dg-format-percent.filter.ts' />
/// <reference path='src/utils/dg-object-helper.service.ts' />


/// <reference path='src/exceptions/dg.exceptions.ts' />
/// <reference path='src/exceptions/http-error-handler-interceptor.ts' />


/// <reference path='src/logger/dg-logger.module.ts' />
/// <reference path='src/logger/dg-logger.config.ts' />
/// <reference path='src/logger/dg-http-logger-interceptor.ts' />
/// <reference path='src/logger/dg-log.service.ts' />

/// <reference path='src/clients/client.module.ts' />
/// <reference path='src/clients/client-info.service.ts' />
/// <reference path='src/clients/application-info.service.ts' />

/// <reference path='src/restfull-api/dg.restfull-api.ts' />
/// <reference path='src/restfull-api/restfull-api-client.service.ts' />

/// <reference path="src/navigation/dg.navigation.ts" />
/// <reference path='src/navigation/nav-action.ts' />
/// <reference path='src/navigation/navigation.service.ts' />
/// <reference path='src/navigation/exports-list.ts' />
/// <reference path='src/navigation/nav-icon.ts' />
/// <reference path='src/navigation/actions-list.ts' />
/// <reference path='src/navigation/reload.ts' />
/// <reference path='src/navigation/menu-item.ts' />
/// <reference path='src/navigation/menu-dropdown-item.ts' />


/// <reference path='src/loading/dg.loading.ts' />
/// <reference path='src/loading/loading.ts' />
/// <reference path='src/loading/dg-view.directive.ts' />
/// <reference path='src/loading/dg-data-loader.directive.ts' />
/// <reference path='src/loading/data-loader.service.ts' />

/// <reference path='src/lists/dg.lists.ts' />
/// <reference path='src/lists/list.ts' />
/// <reference path='src/lists/list-options.service.ts' />
/// <reference path='src/lists/sort-action-list.ts' />
/// <reference path='src/lists/filter-action-list.ts' />
/// <reference path='src/lists/selected-filters.ts' />
/// <reference path='src/lists/paging-counter.ts' />
/// <reference path='src/lists/search-pattern.ts' />
/// <reference path='src/lists/show-all.ts' />
/// <reference path='src/lists/refresh.ts' />
/// <reference path='src/lists/view-switcher.ts' />
/// <reference path='src/lists/pagination.ts' />
/// <reference path='src/lists/list-item-selected-channel.service.ts' />

/// <reference path='src/lists/badge-list/badge-list.ts' />
/// <reference path='src/lists/grid-list/grid-list.ts' />
/// <reference path='src/lists/grid-list/grid-list-configuration.service.ts' />

/// <reference path='src/lists/chart/plotly-chart.ts' />
/// <reference path='src/lists/chart/chart.service.ts' />

/// <reference path="src/objects/dg.objects.ts" />
/// <reference path="src/objects/object.service.ts" />
/// <reference path='src/objects/object-displayer.ts' />
/// <reference path='src/objects/object-editor.ts' />
/// <reference path="src/objects/form-editor.directive.ts" />

/// <reference path='src/objects/properties/property-editor.directive.ts' />
/// <reference path='src/objects/properties/property-displayer.directive.ts' />

/// <reference path='src/objects/properties/layouts/display-layout.controller.ts' />
/// <reference path='src/objects/properties/layouts/form-control-layout.ts' />
/// <reference path='src/objects/properties/layouts/colon-layout.ts' />
/// <reference path='src/objects/properties/layouts/dl-layout.ts' />
/// <reference path='src/objects/properties/layouts/grid-cell-layout.ts' />
/// <reference path='src/objects/properties/layouts/selectable-item-layout.ts' />
/// <reference path='src/objects/properties/layouts/value-only-layout.ts' />

/// <reference path='src/objects/properties/child/child-list.ts' />

/// <reference path='src/objects/properties/lookup/lookup.directive.ts' />
/// <reference path='src/objects/properties/lookup/lookup.ts' />
/// <reference path='src/objects/properties/lookup/reference-displayer.ts' />
/// <reference path='src/objects/properties/lookup/value-object-displayer.ts' />

/// <reference path='src/objects/properties/lookup/nya-select.ts' />

/// <reference path='src/objects/properties/text/multiline-text.directive.ts' />
/// <reference path='src/objects/properties/text/multiline-text-displayer.ts' />
/// <reference path='src/objects/properties/text/wysiwyg.directive.ts' />
/// <reference path='src/objects/properties/text/wysiwyg-displayer.directive.ts' />
/// <reference path='src/objects/properties/text/text.directive.ts' />
/// <reference path='src/objects/properties/text/text-displayer.ts' />

/// <reference path='src/objects/properties/bool/bool.directive.ts' />
/// <reference path='src/objects/properties/bool/bool-displayer.ts' />
/// <reference path='src/objects/properties/number/amount.directive.ts' />
/// <reference path='src/objects/properties/number/amount-displayer.ts' />
/// <reference path='src/objects/properties/number/percent.directive.ts' />

/// <reference path='src/objects/properties/date/date.service.ts' />
/// <reference path='src/objects/properties/date/period.service.ts' />
/// <reference path='src/objects/properties/date/period-displayer.ts' />
/// <reference path='src/objects/properties/date/period.ts' />
/// <reference path='src/objects/properties/date/datepicker-popup.ts' />
/// <reference path='src/objects/properties/date/date-displayer.ts' />
/// <reference path='src/objects/properties/date/period.service.ts' />
/// <reference path='src/objects/properties/date/custom-date-range.service.ts' />

/// <reference path='src/objects/properties/date/custom-date-range.ts' />
/// <reference path='src/objects/properties/date/period.service.ts' />

/// <reference path='src/objects/properties/date/date-range-displayer.ts' />

/// <reference path='src/objects/properties/files/base64-file.ts' />
/// <reference path='src/files/dg.files.module.ts' />
/// <reference path='src/files/blob-storage.service.ts' />
/// <reference path='src/files/file-upload.ts' />
/// <reference path='src/objects/image-viewer.ts' />
/// <reference path='src/objects/form-errors.ts' />
/// <reference path='src/objects/object-tasks-status.ts' />
/// <reference path='src/objects/validation-extension.directive.ts' />
/// <reference path='src/objects/multi-part-property-value-extension.directive.ts' />

/// <reference path='src/actions/dg.actions.ts' />
/// <reference path='src/actions/list-query/default-list-query-oprions.provider.ts' />
/// <reference path='src/actions/list-query/query-manipulator.ts' />
/// <reference path='src/actions/query-invoker.ts' />
/// <reference path='src/actions/action.service.ts' />
/// <reference path='src/actions/action-invoker.ts' />
/// <reference path='src/actions/query-execution-strategy.factory.ts' />

/// <reference path='src/actions/command/command-executed-channel.service.ts' />
/// <reference path='src/actions/command/command-invoker.ts' />
/// <reference path='src/actions/query-result/query-result-displayer.ts' />
/// <reference path='src/actions/export/export-invoker.ts' />
/// <reference path='src/actions/widget/widget.ts' />
/// <reference path='src/actions/kpi/kpi.ts' />
/// <reference path='src/actions/kpi/kpi-bar.ts' />

/// <reference path='src/actions/dashboard/dashboard.ts' />


/// <reference path='src/modals/dg.modals.ts' />
/// <reference path='src/modals/modal.service.ts' />
/// <reference path='src/modals/modal-header.ts' />


/// <reference path='src/modules/users/users.module.ts' />
/// <reference path='src/modules/users/users.service.ts' />
/// <reference path='src/modules/users/users.route.ts' />
